import ActionModal from "components/Settings/components/ActionModal";
import RadioButton from "components/BaseWidgets/radioButton";
import { useState } from "react";
import { RadioData } from "components/Settings/components/DeleteAccount/helper";

function DeactivateModal({ open, setOpen, onSubmit, isLoading }) {
  const [value, setValue] = useState(2);

  return (
    <ActionModal
      title="Deactivate your account"
      description="Deactivating your account will hide your profile and remove access to matchmaking features. You can reactivate anytime by logging back in."
      open={open}
      setOpen={setOpen}
      centerMode={false}
      centered
      footer={{
        right: {
          label: "Deactivate",
          action: () => onSubmit(value),
          isLoading: isLoading,
        },
      }}
    >
      <div className="mt-8 security-privacy-tab">
        <span className="font-title-sm fw-700">Reason for deletion</span>
        <RadioButton
          options={RadioData}
          variant="primary"
          className="privacy-radio mt-4"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    </ActionModal>
  );
}

export default DeactivateModal;
